module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('van-popup', {
    attrs: {
      "position": "bottom",
      "lazy-render": false
    },
    model: {
      value: (_vm.popupShow),
      callback: function($$v) {
        _vm.popupShow = $$v
      },
      expression: "popupShow"
    }
  }, [_c('div', {
    staticClass: "page bg-gray page-flex pb-fixed-btn"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageInfo.queryKey),
      expression: "pageInfo.queryKey"
    }],
    staticClass: "center-input fs-28",
    attrs: {
      "type": "search",
      "placeholder": "搜索收货人姓名、手机号、订单号"
    },
    domProps: {
      "value": (_vm.pageInfo.queryKey)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pageInfo, "queryKey", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("\n                搜索\n            ")])]), _vm._v(" "), (_vm.showTipBox) ? _c('div', {
    staticClass: "tip-box"
  }, [_c('div', {
    staticClass: "alifont icon-tongzhi"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex1 fs-28 font-bold ml-20 mr-20"
  }, [_vm._v("同一收货人多选可合并订单一格寄存")]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-cha click",
    staticStyle: {
      "font-size": ".32rem"
    },
    on: {
      "click": function($event) {
        _vm.showTipBox = false;
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "posi-rel flex1 pd-025"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "mt-20 person-order"
    }, _vm._l((item.orderInfoVo), function(order, $orderIndex) {
      return _c('div', {
        key: $orderIndex,
        staticClass: "order pd-250 click",
        on: {
          "click": function($event) {
            return _vm.chooseOrder(order)
          }
        }
      }, [_c('div', {
        staticClass: "flex"
      }, [_c('div', {
        staticClass: "flex1 mr-20"
      }, [($orderIndex == 0) ? _c('div', {
        staticClass: "fs-28 color-000"
      }, [_vm._v("收货人：" + _vm._s(order.userName) + "  "), _c('span', {
        staticClass: "ml-10"
      }, [_vm._v(_vm._s(order.userMobile))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "mt-8 fs-24 color-999"
      }, [_vm._v("订单号：" + _vm._s(order.orderNo))])]), _vm._v(" "), _c('div', {
        staticClass: "choose-icon alifont ",
        class: _vm.chooseOrderIdArray.indexOf(order.orderId) > -1 ? 'color-main icon-xuanzhong' : 'icon-weixuanzhong color-999'
      })]), _vm._v(" "), _c('div', {
        staticClass: "product-list"
      }, _vm._l((order.productList), function(prod, $prodIndex) {
        return _c('div', {
          key: $prodIndex,
          staticClass: "product-item"
        }, [_c('img', {
          attrs: {
            "src": prod.imgPathView,
            "alt": ""
          }
        }), _vm._v(" "), (prod.productQty > 1) ? _c('div', {
          staticClass: "numbers"
        }, [_vm._v(_vm._s(prod.productQty) + "件")]) : _vm._e()])
      }), 0)])
    }), 0)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.bindOrder()
      }
    }
  }, [_vm._v("确定")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fa145b9","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/locker/waitOrderList.vue
// module id = yGHe
// module chunks = 51